export interface MetodoPago{
    idMetodoPago: number;
    codigo: string;
    descripcion: string;
    habilitado: boolean;
    selected: boolean;
}

export interface FormaPago {
  idFormaPago: number;
  codigo: string;
  descripcion: string;
  habilitado: boolean;
  selected: boolean;
}

export class FacturaSAT {
    subTotal: number;
    iva: number;
    total: number;
    fecha: Date;
    lugarExpedicion: string;
    formaPago: string;
    metodoPago: string;
    tipoComprobante: string;
    moneda: string;
    certificado: string;
    version: string;
    folioFiscal: string;
    emisor: EmisorSAT;
    receptor: ReceptorSAT;
    impuesto: string;
    tipoFactor: string;
    tasaOCuota: number;
    contenidoXML: string;
}

export class EmisorSAT {
    rfc: string;
    nombre: string;
    regimenFiscal: string;
}

export class ReceptorSAT {
    rfc: string;
    nombre: string;
    usoCFDI: string;
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/facturaSAT.ts